import { Grid, Box } from '@mui/material'
import Typography from '@mui/material/Typography'
import axios from 'axios'
import { getDroppedOrSelectedFiles } from 'html5-file-selector'
import React from 'react'
import Dropzone, { IDropzoneProps, ILayoutProps } from 'react-dropzone-uploader'
import { StepComponentProps } from 'react-step-builder'
import config from '../../config'
import stepIcon from '../../images/step-illustration-logo.png'
import analytics from '../../libs/analytics'
import Navigation from './common/Navigation'
import OnboardStepper from './common/OnboardStepper'
import Crop from './components/Crop'
import DropZoneInput from './components/DropZoneInput'

class StepLogo extends React.Component<StepComponentProps> {
  state: {
    restoredFiles: File[]
    uploading: boolean
    fileSizeError: boolean
  } = {
    restoredFiles: [],
    uploading: false,
    fileSizeError: false,
  }

  render() {
    const { uploading } = this.state

    return (
      <Grid container direction="column">
        <Grid item sx={{ mb: { xs: 3, sm: 4, md: 4 } }}>
          <OnboardStepper activeStep={2} />
        </Grid>
        <Grid item>
          <Grid container direction="row" spacing={5}>
            <Grid item xs={12} sm={12} md={7}>
              <Box>
                <Typography variant="h1">Make it your own</Typography>
                <Typography variant="subtitle1">Upload your company logo (Optional)</Typography>
              </Box>
              <Box sx={{ mt: 2, mb: 6, maxWidth: '500px' }}>
                <Grid component="form" container direction="column">
                  <Dropzone
                    onChangeStatus={this.onChangeStatus}
                    LayoutComponent={this.uploadLayout}
                    multiple={false}
                    accept="image/*"
                    maxFiles={1}
                    onSubmit={this.handleSubmit}
                    maxSizeBytes={1024 * 1024 * 5} /* 5 MiB */
                    InputComponent={DropZoneInput}
                    getFilesFromEvent={this.getFilesFromEvent}
                    initialFiles={this.state.restoredFiles}
                    autoUpload={false}
                    canRestart={!this.state.restoredFiles?.length}
                  />
                </Grid>
              </Box>
            </Grid>
            <Grid item md={5} sx={{ display: { xs: 'none', sm: 'none', md: 'block' } }}>
              <img src={stepIcon} alt="Step logo" width={260} height={327} />
            </Grid>
          </Grid>
        </Grid>
        <Grid item>
          {Navigation({
            props: this.props,
            component: this,
            disabled: uploading,
          })}
        </Grid>
      </Grid>
    )
  }

  handleSubmit: IDropzoneProps['onSubmit'] = (files, allFiles) => {
    allFiles.forEach((f) => f.remove())
  }

  handleRemove = () => {
    this.props.setState('logoInputFiles', [])
    this.props.setState('asset_id', undefined)
  }

  handleUpload = async (image) => {
    this.props.setState('logoInputFiles', [image])
    this.setState({
      uploading: true,
    })
    let formData = new FormData()
    formData.append('file', image)
    const result = await axios.post(`${config.assets_api_url}/upload`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    })
    this.setState({
      uploading: false,
    })
    this.props.setState('asset_id', result.data.id)
  }

  onChangeStatus = (data) => {
    switch (data.meta.status) {
      case 'error_file_size':
        this.setState({ fileSizeError: true })
        data.remove()
        break
      case 'done':
        this.setState({ fileSizeError: false })
        break
      default:
        break
    }
  }

  uploadLayout = ({ input, previews, dropzoneProps, files, extra }: ILayoutProps) => {
    const showSizeError = this.state.fileSizeError

    return (
      <Grid container justifyContent="center">
        {files[0] && !showSizeError ? (
          <Crop
            file={files[0]}
            onSave={this.handleUpload}
            onRemove={this.handleRemove}
            uploading={this.state.uploading}
          />
        ) : (
          <div {...dropzoneProps}>{input}</div>
        )}
        {showSizeError ? <Typography sx={{ color: 'red' }}>Max upload file size is 5 MB</Typography> : null}
      </Grid>
    )
  }

  getFilesFromEvent(e): Promise<File[]> {
    return new Promise((resolve) => {
      getDroppedOrSelectedFiles(e).then((chosenFiles) => {
        resolve(chosenFiles.map((f) => f.fileObject))
      })
    })
  }

  componentDidMount() {
    analytics.sendEvent('page@StepLogo')
    this.setState({
      restoredFiles: this.props.getState('logoInputFiles', undefined),
    })
  }
}

export default StepLogo
